import { render, staticRenderFns } from "./ExpandableController.vue?vue&type=template&id=560255a0"
import script from "./ExpandableController.vue?vue&type=script&lang=js"
export * from "./ExpandableController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports